var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircle366(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 488.784,
    height: 488.784,
    viewBox: "0 0 488.784 488.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-366",
    transform: "matrix(0.438, 0.899, -0.899, 0.438, 328.543, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#eaeaea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.769,
    cy: 182.769,
    rx: 182.769,
    ry: 182.769,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.769,
    cy: 182.769,
    rx: 182.269,
    ry: 182.269,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    transform: "translate(347.531 123.573)",
    fill: "#eaeaea",
    stroke: "#eaeaea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.519,
    cy: 9.519,
    rx: 9.519,
    ry: 9.519,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.519,
    cy: 9.519,
    rx: 9.019,
    ry: 9.019,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    transform: "translate(274.328 324.182)",
    fill: "#ebebeb",
    stroke: "#eaeaea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.519,
    cy: 9.519,
    rx: 9.519,
    ry: 9.519,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.519,
    cy: 9.519,
    rx: 9.019,
    ry: 9.019,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    transform: "translate(274.985 22.692)",
    fill: "#eaeaea",
    stroke: "#eaeaea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.531,
    cy: 6.531,
    rx: 6.531,
    ry: 6.531,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.531,
    cy: 6.531,
    rx: 6.031,
    ry: 6.031,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle366);
export default __webpack_public_path__ + "static/media/circle-366.60c0282bdae2b3e3d947a9d3f0036967.svg";
export { ForwardRef as ReactComponent };